<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment"><br/><br/><br/><br/><br/><br/><br/>
<p style="text-align: center;text-transform:uppercase;"><em>Prepare for the unknown by studying how others in the past have coped with the unforeseeable and the<br/> unpredictable.</em></p><br/>
<p style="text-align: center;text-transform:uppercase;"><strong><em>―George S. Patton</em></strong></p><br/>
<p style="text-align: center;text-transform:uppercase;"><em>It is not often that nations learn from the past, even rarer that they draw the correct conclusions from it.</em></p><br/>
<p style="text-align: center;text-transform:uppercase;"><strong><em>―Henry Kissinger</em></strong></p><br/>
<p style="text-align: center;text-transform:uppercase;"><em>history is in constant rotation. do we learn from it, or is it evolving into a beast that knows how to hide within <br/>the shadows?</em></p><br/>
<p style="text-align: center;text-transform:uppercase;"><strong><em>―Gregory S. Hudson</em></strong></p><br/>
<p style="text-align: center;text-transform:uppercase;"><em>A beast of knowledge filled with – what if – and – never again. a beast that manipulates the facts and disguises<br/> them in newer, prettier packages of acceptance.</em></p>
<p style="text-align: center;text-transform:uppercase;"><em>wash, rinse, repeat.</em></p><br/>
<p style="text-align: center;text-transform:uppercase;"><strong><em>―Gregory S. Hudson</em></strong></p><br/>
<p style="text-align: center;text-transform:uppercase;"><em><br/>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?5ea3af24